import { qs, qsa, remove } from "@fluorescent/dom";

import ProductItem from "@/lib/product-item";

const selectors = {
  wrappingContainer: ".product__block-complementary-products",
  complementaryProducts: "[data-complementary-products]",
  complementaryProductsContent: "[data-complementary-products-content]",
  productItem: ".product-item",
};

const complementaryProducts = node => {
  const complementaryProducts = qsa(selectors.complementaryProducts, node);

  if (!complementaryProducts.length) return;

  let productItems;

  const {
    recommendationsType,
    productId: id,
    sectionId,
    maxRecommendations,
  } = complementaryProducts[0].dataset;

  if (recommendationsType === "app-recommendations") {
    handleRecommendedProducts();
  } else {
    // Merchant is using custom product list
    productItems = complementaryProducts.forEach(productContainer =>
      ProductItem(productContainer)
    );
  }

  function handleRecommendedProducts() {
    const requestUrl = `${window.theme.routes.productRecommendations}?section_id=${sectionId}&limit=${maxRecommendations}&product_id=${id}&intent=complementary`;

    fetch(requestUrl)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement("div");
        html.innerHTML = text;

        const recommendations = qs(selectors.complementaryProducts, html);
        const renderedProducts = qsa(selectors.productItem, recommendations);

        if (
          recommendations &&
          recommendations.innerHTML.trim().length &&
          renderedProducts.length
        ) {
          complementaryProducts.forEach(
            block => (block.innerHTML = recommendations.innerHTML)
          );

          productItems = complementaryProducts.map(productContainer =>
            ProductItem(productContainer)
          );

          // Remove hidden flag as content has been fetched
          complementaryProducts.forEach(block => {
            remove(block.closest(selectors.wrappingContainer), "hidden");
          });
        }
      })
      .catch(error => {
        throw error;
      });
  }

  function unload() {
    productItems.forEach(item => item.unload());
  }

  return { unload };
};

export default complementaryProducts;
